import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AppConfigService, TokenService } from '@cudirect/shared-ui-library';

@Component({
  selector: 'cu-admin-logout',
  templateUrl: './admin-logout.component.html',
  styleUrls: ['./admin-logout.component.scss']
})
export class AdminLogoutComponent implements OnInit {
  constructor(private tokenService: TokenService, private router: Router, private configService: AppConfigService) {}

  ngOnInit(): void {
    this.tokenService.configureCache(
      this.configService?.settings?.adminPortalTokenStorageType || 'sessionStorage',
      this.configService?.settings?.adminPortalCachedTokenName || 'admin-portal-user-session'
    );
    this.tokenService.clearCachedToken();
    this.router.navigate(['admin/login'], { queryParamsHandling: 'preserve' });
  }
}
